import { render, staticRenderFns } from "./PanelWithProductEditor.vue?vue&type=template&id=6a57b5d4&lang=pug&"
import script from "./PanelWithProductEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithProductEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithProductEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports